// import Vue from 'vue';
import axios from 'axios';
// import VueAxios from 'vue-axios';
// import store from '@/store';

// const userToken = store.getters.getUserToken;
/*
axios.defaults.withCredentials = false;
axios.defaults.headers = { "Accept": "application/json", "Content-type": "application/json" };
axios.defaults.baseURL = process.env.VUE_APP_API_HOST || 'http://localhost:8000/';

// if (userToken) {
//   axios.defaults.headers.Authorization = `Bearer ${userToken}`;
// }

Vue.use(VueAxios, axios);
*/

export default axios.create({
    baseURL: process.env.VUE_APP_API_HOST || 'http://localhost:8000/',
    headers: {
        "Accept": "application/json",
        "Content-type": "application/json"
    }
});
